export class Utility {
  isOnline () {
    return navigator && navigator.onLine
  }

  getCookie (cname) {
    var name = cname + '='
    var decodedCookie = decodeURIComponent(document.cookie)
    var ca = decodedCookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return JSON.parse(c.substring(name.length, c.length))
      }
    }
    return undefined
  }

  getImagePath (fullname) {
    if (fullname) {
      try {
        return `/static/image_asset/${fullname}?version=${process.env.VERSION}`
      } catch (ex) {
        return ''
      }
    }
    return ''
  }

  getImageSet (name) {
    if (name) {
      var x = `${name}.png`
      var xx = `${name}@2x.png`
      // var xxx = `${name}@3x.png`
      // var xxxx = `${name}@4x.png`
      // return `${this.getImagePath(x)} 1x, ${this.getImagePath(xx)} 2x, ${this.getImagePath(xxx)} 3x, ${this.getImagePath(xxxx)} 4x`
      return `${this.getImagePath(x)} 1x, ${this.getImagePath(xx)} 2x`
    }
    return ''
  }

  resizeImage (base64Str, maxWidth, maxHeight, orientation, callback) {
    var canvas = document.createElement('canvas')
    var context = canvas.getContext('2d')
    var img = document.createElement('img')
    img.onload = function () {
      var iw = img.width
      var ih = img.height
      var scale = Math.min(((maxWidth === -1 ? iw : maxWidth) / iw), ((maxHeight === -1 ? ih : maxHeight) / ih))
      var iwScaled = iw * scale
      var ihScaled = ih * scale
      switch (orientation) {
        case 2:
          canvas.width = iwScaled
          canvas.height = ihScaled
          // horizontal flip
          context.translate(iwScaled, 0)
          context.scale(-1, 1)
          context.drawImage(img, 0, 0, iwScaled, ihScaled)
          break
        case 3:
          canvas.width = iwScaled
          canvas.height = ihScaled
          // 180° rotate left
          context.translate(iwScaled, ihScaled)
          context.rotate(Math.PI)
          context.drawImage(img, 0, 0, iwScaled, ihScaled)
          break
        case 4:
          canvas.width = iwScaled
          canvas.height = ihScaled
          // vertical flip
          context.translate(0, ihScaled)
          context.scale(1, -1)
          context.drawImage(img, 0, 0, iwScaled, ihScaled)
          break
        case 5:
          canvas.width = ihScaled
          canvas.height = iwScaled
          // vertical flip + 90 rotate right
          context.rotate(0.5 * Math.PI)
          context.scale(1, -1)
          context.drawImage(img, 0, 0, iwScaled, ihScaled)
          break
        case 6:
          canvas.width = ihScaled
          canvas.height = iwScaled
          // 90° rotate right
          context.rotate(0.5 * Math.PI)
          context.translate(0, -ihScaled)
          context.drawImage(img, 0, 0, iwScaled, ihScaled)
          break
        case 7:
          canvas.width = ihScaled
          canvas.height = iwScaled
          // horizontal flip + 90 rotate right
          context.rotate(0.5 * Math.PI)
          context.translate(iwScaled, -ihScaled)
          context.scale(-1, 1)
          context.drawImage(img, 0, 0, iwScaled, ihScaled)
          break
        case 8:
          canvas.width = ihScaled
          canvas.height = iwScaled
          // 90° rotate left
          context.rotate(-0.5 * Math.PI)
          context.translate(-iwScaled, 0)
          context.drawImage(img, 0, 0, iwScaled, ihScaled)
          break
        default:
          canvas.width = iwScaled
          canvas.height = ihScaled
          context.drawImage(img, 0, 0, iwScaled, ihScaled)
          break
      }
      context.restore()
      callback(canvas.toDataURL())
    }
    img.src = base64Str
  }

  getOrientation (file, callback) {
    var reader = new FileReader()
    reader.onload = function (event) {
      const caseList = [-1, -2]
      var view = new DataView(event.target.result)

      if (view.getUint16(0, false) !== 0xFFD8) {
        return callback(caseList[1])
      }
      var length = view.byteLength
      var offset = 2
      while (offset < length) {
        var marker = view.getUint16(offset, false)
        offset += 2

        if (marker === 0xFFE1) {
          if (view.getUint32(offset += 2, false) !== 0x45786966) {
            return callback(caseList[0])
          }
          var little = view.getUint16(offset += 6, false) === 0x4949
          offset += view.getUint32(offset + 4, little)
          var tags = view.getUint16(offset, little)
          offset += 2
          for (var i = 0; i < tags; i++) {
            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
              console.log(view.getUint16(offset + (i * 12) + 8, little))
              return callback(view.getUint16(offset + (i * 12) + 8, little))
            }
          }
        } else if ((marker & 0xFF00) !== 0xFF00) {
          break
        } else {
          offset += view.getUint16(offset, false)
        }
      }
      return callback(caseList[0])
    }
    reader.readAsArrayBuffer(file)
  }

  createFileFromUrl (dataurl, filename) {
    var arr = dataurl.split(',')
    var mime = arr[0].match(/:(.*?);/)[1]
    var bstr = atob(arr[1])
    var n = bstr.length
    var u8arr = new Uint8Array(n)
    if (filename === null || filename === '' || filename === undefined) {
      filename = (new Date().getTime()) + '_' + Math.round(Math.random() * 10000) + '.png'
    }
    return new File([u8arr], filename, {type: mime})
  }

  boundingOnMap (mapObject, locationList) {
    var boundingBox = {
      minLat: 13.729319976238605,
      minLon: 100.53589001297951,
      maxLat: 13.729319976238605,
      maxLon: 100.53589001297951
    }
    if (locationList.length > 0) {
      boundingBox = window.longdo.Util.locationBound(locationList)
      mapObject.bound(boundingBox)
    } else {
      mapObject.bound(boundingBox)
    }
  }

  getWindowWidth (event) {
    return document.documentElement.clientWidth
  }

  getWindowHeight (event) {
    return document.documentElement.clientHeight
  }

  isMobileOrTablet () {
    var check = false
    var a = navigator.userAgent || navigator.vendor || window.opera
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
      check = true
    }
    return check
  }

  isiOS () {
    var iDevices = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ]

    // if (!!navigator.platform) {
    if (navigator) {
      if ('platform' in navigator) {
        while (iDevices.length) {
          if (navigator.platform === iDevices.pop()) {
            return true
          }
        }
      }
    }
    return false
  }

  iOSVersion () {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
      // supports iOS 2.0 and later: <https://bit.ly/TJjs1V>
      const v = (navigator.appVersion).match(/OS ?X? (\d+)_(\d+)_?(\d+)?/)
      return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)]
    }
    return [0, 0, 0]
  }

  isIpadOS () {
    if ('maxTouchPoints' in navigator) {
      return navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform)
    }
    return false
  }

  isAndroidDevice () {
    const ua = navigator.userAgent || navigator.vendor || window.opera
    return (/android/i.test(ua))
  }

  getUserAgentMeta () {
    var userAgentMeta = document.querySelector('meta[name="user_agent"]')
    if (userAgentMeta !== null) {
      var content = userAgentMeta.getAttribute('content')
      if ((navigator.userAgent.indexOf('PromptPai') !== -1 || navigator.userAgent.indexOf('LongdoJsInterface') !== -1) && content === 'iOS application') { // promptpai ios app
        return content
      } else if (content === 'iOS application') { // promptpai ios browser or other ios app
        return 'iOS browser'
      }
      if (content !== null) {
        return content
      } else {
        return ''
      }
    }
    return ''
  }

  getDateString (timestamp, lang) {
    var date = new Date(Number(timestamp) * 1000)
    var day = `0${date.getDate()}`
    var month = `0${date.getMonth() + 1}`
    var year = Number(date.getFullYear()) + (lang === 'th' ? 543 : 0)
    return `${day.substr(-2)}/${month.substr(-2)}/${year}`
  }

  getTimeString (timestamp, lang) {
    var date = new Date(Number(timestamp) * 1000)
    var hours = date.getHours()
    var minutes = `0${date.getMinutes()}`
    return `${hours}:${minutes.substr(-2)}`
  }

  parseJwt (token) {
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))

    return JSON.parse(jsonPayload)
  }

  isFacebookWebview () {
    const ua = navigator.userAgent || navigator.vendor || window.opera
    return (/fb/i.test(ua.toLowerCase()))
  }

  isLineWebview () {
    const ua = navigator.userAgent || navigator.vendor || window.opera
    return (/line/i.test(ua.toLowerCase()))
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/utility.js